import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'firebaseAppId',
  initialState: null as null | string,
  reducers: {
    setFirebaseAppId(state, action: PayloadAction<string | null>) {
      return action.payload || null;
    },
  },
});

export const { setFirebaseAppId } = slice.actions;

export default slice.reducer;
